import { render, staticRenderFns } from "./MaterialInput.vue?vue&type=template&id=4c3efaa7&scoped=true&"
import script from "./MaterialInput.vue?vue&type=script&lang=js&"
export * from "./MaterialInput.vue?vue&type=script&lang=js&"
import style0 from "./MaterialInput.vue?vue&type=style&index=0&id=4c3efaa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3efaa7",
  null
  
)

export default component.exports